module.exports = __webpack_public_path__ + "media/images/icons/flags/PL-2f86034e71a65b06d0642cebcceebbdb.svg";